import DemoPage from "./DemoPage";

export default DemoPage;

export * from "./DemoPage";
